<template>
  <div class="text-center final-step">
    <h1 class="pb-2">
      <b-icon-check-circle-fill /><br />
      Дякуємо
    </h1>
    <h5>Ми надіслали вам <strong> СМС із даними для входу</strong></h5>
    <p>
      аби продовжити, потрібно увійти, <br />використовуючи дані з повідомленя
    </p>
    <b-button class="mt-4" variant="primary" size="lg" :to="{ name: 'login' }">
      Увійти
    </b-button>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.final-step {
  padding: 40px 0px;
  h1 {
    svg {
      fill: rgb(39, 153, 39);
    }
  }
}
</style>
